const refreshStatusStyle = (theme) => ({
	statusWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			justifyContent: 'flex-start',
			alignItems: 'center',
		},
	},
	refreshButton: {
		minWidth: '130px',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
});

export default refreshStatusStyle;
